import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";
export default _Object$freeze({
  NEW: {
    color: '#bdbdbd',
    text: 'New'
  },
  IN_PROGRESS: {
    color: '#444749',
    text: 'In progress'
  },
  IN_REVIEW: {
    color: '#444749',
    text: 'Under review'
  },
  UPCOMING: {
    color: '#f19d00',
    text: 'Upcoming'
  },
  OPEN_FOR_VIP: {
    color: '#00c18b',
    text: 'Open for restricted'
  },
  OPEN_FOR_EVERYONE: {
    color: '#00c18b',
    text: 'Open for everyone'
  },
  SPECIAL_ROOM_OPEN_FOR_EVERYONE: {
    color: '#00c18b',
    text: 'Special room open'
  },
  ENDED: {
    color: '#bdbdbd',
    text: 'Archived'
  },
  // Not attached to MicroService statuses
  COMPLETED: {
    color: '#00c18b',
    text: 'Completed'
  },
  // Room statuses
  COMPLETE: {
    color: '#00c18b',
    text: 'COMPLETE'
  },
  INCOMPLETE: {
    color: '#f19d00',
    text: 'INCOMPLETE'
  }
});